exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3zeXU7Xa9GZuNdEm_1XG93{display:flex;justify-content:space-between;padding:3px 40px}a{color:#444}a[href*=\"linkedin\"]:hover{color:#226088}a[href*=\"mailto\"]:hover{color:#883121}a[href*=\"github\"]:hover{color:#000}a[href*=\"facebook\"]:hover{color:#294488}a[href*=\"angel\"]:hover{color:#1d1d1d}\n", ""]);
// Exports
exports.locals = {
	"list": "_3zeXU7Xa9GZuNdEm_1XG93"
};